import i18n from 'i18next';
import { reactI18nextModule } from 'react-i18next';
//import LngDetector from 'i18next-browser-languagedetector';
import frenchTrans from './frenchTrans.json';
import engTrans from './engTrans.json';

i18n
  .use(reactI18nextModule) // passes i18n down to react-i18next
  .init({
    resources: {
      FR: { lang: frenchTrans },
      EN: { lang: engTrans }
    },
    lng: 'EN',
    keySeparator: false, // we do not use keys in form messages.welcome
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n.js